import Box from '@material-ui/core/Box';
import React, {Component} from 'react';
import { withRouter } from 'react-router';
import { withUser } from '../../../utils/ReactWrappers';

import MeetingList from '../../lists/MeetingList';
import Loader from '../../widgets/Loader';

class ClientMeetings extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
        const {isLoading} = this.state;

		if(isLoading) {
            return <Loader />;
        }

        return (
			<Box>
                {this.renderMeetings()}
            </Box>
		);
	}

    renderMeetings() {
        const {client} = this.props;

        return <MeetingList clientId={client._id} />;
    }
}

export default withRouter(withUser(ClientMeetings));
